import { useMemo } from 'react';
import { compact } from 'lodash';

import { ServiceLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import {
   AlignItems,
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
   JustifyContent,
} from '@dreryk/react-components';
import { addressFormatter } from '@dreryk/react-common';

import { receptionServiceTranslationKeys } from '../../../../../../translations';

const t = receptionServiceTranslationKeys.shared.form.components.serviceLocationsInteractiveTable.headers;

export const useServiceLocationsInteractiveTableColumnConfigurationOptions = (
   readOnly: boolean | undefined
): InteractiveTableColumnConfiguration<ServiceLocation>[] => {
   return useMemo((): InteractiveTableColumnConfiguration<ServiceLocation>[] => {
      const columnWidths = createDynamicColumnsWidth({
         locationIdentifier: '0px',
         name: '50%',
         address: '50%',
         options: readOnly ? '0px' : '24px',
      });

      return compact([
         {
            name: 'locationIdentifier',
            width: columnWidths.locationIdentifier,
            renderer: ({ bean, index }) => {
               return (
                  <InteractiveTable.ControllerCell testId={'id'} name={'id'} index={index} defaultValue={bean.id} />
               );
            },
            hidden: true,
         },
         {
            name: 'name',
            label: t.name,
            width: columnWidths.name,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            renderer: ({ bean, index }) => {
               return (
                  <InteractiveTable.TextViewCell testId={'name'} name={'name'} index={index} defaultValue={bean.name} />
               );
            },
         },
         {
            name: 'address',
            width: columnWidths.address,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            label: t.address,
            renderer: ({ bean, index }) => {
               return (
                  <InteractiveTable.CustomCell
                     testId={'address'}
                     name={'address'}
                     index={index}
                     defaultValue={bean.address}
                  >
                     {(value) => <>{addressFormatter(value)}</>}
                  </InteractiveTable.CustomCell>
               );
            },
         },
         readOnly
            ? null
            : {
                 name: 'options',
                 width: columnWidths.options,
                 renderer: ({ index }) => {
                    return <InteractiveTable.DeleteRowCell index={index} />;
                 },
              },
      ]);
   }, [readOnly]);
};
